/* whiteboxSecret.ts */

const _a = [0x1e, 0x05, 0x15, 0x1f];
const _b = [0x7a, 0x77, 0x03, 0x03];
const _c = [0x60, 0x02, 0x6a, 0x15];
const _d = [0x6b, 0x13, 0x65, 0x03];

const _m = [0x54, 0x33, 0x58, 0x52];

const _r = (x: number, y: number) => (x + 256) ^ y;
const _g = (arr: number[], k: number) => new Uint8Array(arr.map(v => _r(v, k)));

export const _S0 = (): Uint8Array => {
  const p0 = _g(_a, _m[0]);
  const p1 = _g(_b, _m[1]);
  const p2 = _g(_c, _m[2]);
  const p3 = _g(_d, _m[3]);

  const o = new Uint8Array(p0.length + p1.length + p2.length + p3.length);

  let i = 0;
  o.set(p0, i); i += p0.length;
  o.set(p1, i); i += p1.length;
  o.set(p2, i); i += p2.length;
  o.set(p3, i);

  return o;
};
